<template >
  <v-container >
    <div class="bgColor"></div>
    <!-- Alert -->
    <v-snackbar :timeout="6000" color="error" top v-model="$store.getters.getErrorMessage">
      Invalid Credentials
    </v-snackbar>
    <v-container class="loginPos" v-if="$store.getters.getLoggedState === false">
      <v-layout row wrap>
        <!-- Logo -->
        <v-flex xs12 text-xs-center> <img v-if="$vuetify.breakpoint.mdAndUp" src="public\images\logos\EW_LOGO.png" height="200">
          <img v-else src="public\images\logos\EW_LOGO.png" height="150">
        </v-flex>
        <!-- Form -->
        <v-flex xs12 md6 offset-md3>
          <v-form v-model="valid">
            <v-text-field color="success" autofocus placeholder="E-mail" v-model="email" :rules="emailRules" required></v-text-field>
            <v-text-field color="success" @keyup.enter="submit" placeholder="Password" v-model="password" :rules="passwordRules" required :append-icon="e1 ? 'visibility_off' : 'visibility'" :append-icon-cb="() => (e1 = !e1)" :type="e1 ? 'text' : 'password'"> </v-text-field>
          </v-form>
        </v-flex>
        <!-- Button -->
        <v-flex xs12 md6 offset-md3 text-xs-center>
          <v-btn color="success" fab large :disabled="!emailRules" @click="submit">
            <v-icon>done</v-icon>
          </v-btn>
        </v-flex>        
      </v-layout>
    </v-container>
    <v-container class="loginPos" v-else>
      <v-layout row wrap>
        <!-- Logo -->
        <v-flex xs12 text-xs-center> <img v-if="$vuetify.breakpoint.mdAndUp" src="public\images\logos\EW_LOGO.png" height="200">
          <img v-else src="public\images\logos\EW_LOGO.png" height="150">
        </v-flex>  
         <v-flex xs12 text-xs-center>
           <v-progress-circular :width="5" color="primary" indeterminate></v-progress-circular>  
         </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      e1: false, //password visibility
      valid: false,
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ]
    };
  },
  methods: {
    submit: function() {
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
      this.$emit("showToolbar");
    },
    test(){
      console.log("hi")
    }
  }
};
</script>

<style >
.bgColor {
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden !important;
}

.loginPos {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue